import { styled } from '@mui/material'

const InsideDiameterOption = styled('span')({
	marginRight: '50px',
	minWidth: 100
})

export default InsideDiameterOption